import { render, staticRenderFns } from "./SignUpOne.vue?vue&type=template&id=04d1f5bc"
import script from "./SignUpOne.vue?vue&type=script&lang=js"
export * from "./SignUpOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports